import type { JSX } from 'react';

import { type EmptyPrefetchProps, withPrefetchedData } from '#src/shared/prefetch';

import { Layout } from '../layout';

export const Nonprofit = withPrefetchedData(
	function Nonprofit(_props: EmptyPrefetchProps): JSX.Element {
		return <Layout />;
	},
	{
		prefetchName: __MODULE_HASH__,
		pageTitle: ({ fromTemplate }) => fromTemplate('For Nonprofits'),
	},
);
